import { Clock } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { eur } from "@/lib/api";

export const AGE_OPTIONS = [3, 6, 9, 12, 18, 24];

export const stockMonths = (it) => {
  const s = String(it.delivery_date || it.created_at || "").slice(0, 7);
  if (!/^\d{4}-\d{2}$/.test(s)) return 0;
  const t = new Date();
  return Math.max(0, (t.getFullYear() - Number(s.slice(0, 4))) * 12 + t.getMonth() + 1 - Number(s.slice(5, 7)));
};

export const isOld = (it, limit) => Number(it.qty || 0) > 0 && stockMonths(it) >= limit;

export const StockAgeAlert = ({ oldItems, limit, onLimit, onlyOld, onToggle }) => {
  const value = oldItems.reduce((s, it) => s + Number(it.qty || 0) * Number(it.purchase_price || 0), 0);
  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-sm" data-testid="warehouse-age-alert">
      <Clock className="h-4 w-4 text-amber-300" />
      <span className="font-semibold text-amber-200" data-testid="warehouse-age-count">
        Dlho ležiace položky: {oldItems.length}
      </span>
      <span className="text-muted-foreground">na sklade</span>
      <Select value={String(limit)} onValueChange={(v) => onLimit(Number(v))}>
        <SelectTrigger className="h-8 w-[160px]" data-testid="warehouse-age-limit"><SelectValue /></SelectTrigger>
        <SelectContent>{AGE_OPTIONS.map((m) => <SelectItem key={m} value={String(m)}>{m} a viac mes.</SelectItem>)}</SelectContent>
      </Select>
      {oldItems.length > 0 && (
        <span className="text-muted-foreground" data-testid="warehouse-age-value">viazaná hodnota <b className="font-mono text-amber-200">{eur(value)}</b> bez DPH</span>
      )}
      {(oldItems.length > 0 || onlyOld) && (
        <Button size="sm" variant={onlyOld ? "default" : "outline"} className="ml-auto" onClick={onToggle} data-testid="warehouse-age-filter">
          {onlyOld ? "Zobraziť všetky" : "Zobraziť len tieto"}
        </Button>
      )}
    </div>
  );
};
